module.exports = __webpack_public_path__ + "static/img/nosearchMesg.4a11aa9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nosearchMesg.jpg
// module id = B7bW
// module chunks = 2